// extracted by mini-css-extract-plugin
module.exports = {"header":"AnnoucementHeader_header__1Rb3t","header__icon":"AnnoucementHeader_header__icon__2Ns11","header__title":"AnnoucementHeader_header__title__3ocCK"};